import { formatDate } from '@angular/common';
import  moment from 'moment';
import { AppConstant } from '../constants/app-constant';
import { MyDayOfWeek } from '../enums';

const locale = 'en-US';

export class DateHelpers {
  static textDate = (value, format = AppConstant.DefaultDateFormat) => {
    return formatDate(value, format, locale);
  }
  static getDayOfWeek(dayOfWeek: MyDayOfWeek) {
    let dayNumber: number = dayOfWeek;
    if (dayOfWeek === MyDayOfWeek.Sunday) { dayNumber = 7 };
    return moment().day(dayNumber);
  }
  static firstDayOfWeek() {
    return moment().startOf('isoWeek');
  }
}
